import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../../UIAssetKeys';
import MouseEmitter from './MouseEmitter';

export default class MouseTrailParticle extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {MouseEmitter} mouseEmitter
   */
  constructor(scene, mouseEmitter) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._MouseTrail);

    this.emitterRef = mouseEmitter;
  }

  reset () {
    this.alpha = 1;
    this.scale = 1;
  }

  tick () {
    this.alpha -= 0.04;
    this.scaleX -= 0.02;
    this.scaleY -= 0.02;
  }
}